import { LabelVisibility } from '../types/label';

export const MESSAGES: Record<string, string> = {
  ACTION_CONFLICT:
    "Hold up! Looks like someone (maybe you!) on your team just pulled data from ai-ark. To make sure you don't end up with duplicates or extra charges, we need a quick moment (no more than 5 minutes) to process the last request. Please try again shortly! Thanks for your patience.",

  [LabelVisibility.PRIVATE]: 'Mine',
  [LabelVisibility.INTERNAL]: 'Team',
  [LabelVisibility.ALL]: 'All',
};
